import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRouterModule } from './app.router.module';
import { SharedModule } from '../shared/shared.module';
import { RouterOutlet } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { ClaimModule } from './claims/claim.module';
import { ReimbursementModule } from './reimbursement/reimbursement.module';

@NgModule({
  declarations: [
    AppComponent,  
  ],
  imports: [
    NgbModule,
    ReactiveFormsModule,
    RouterOutlet,    
    HttpClientModule,
    SharedModule,
    ClaimModule,
    ReimbursementModule,
    AppRouterModule //AppRouterModule must be last due to PageNotFoundComponent matching on wildcard routes
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
